<template>
 <h3>国君报价</h3>
   <div class="filter-group">

          <div class="filter-title">选择日期：</div>
              <el-date-picker
                v-model="date"
                type="date"
                placeholder="选择日期"
                :default-value="new Date()"
                @change="fetchData"
                class="date-picker"
              ></el-date-picker>

         <div v-if="loading" class="loading-mask">
            <div class="loading-spinner"></div>
            <p>加载中...</p>
          </div>

          <div v-if="error" class="error-message">
            <p>加载失败，请稍后再试。</p>
          </div>
     </div>
  <div class="filter-group">
      <el-radio-group v-model="selectedBrokerage" @change="applyFilters" >
        <div class="filter-title">指数：</div>
        <el-radio-button
          v-for="option in brokerage_options"
          :key="option.value"
          :label="option.value"
        >{{ option.label }}</el-radio-button>
      </el-radio-group>
    </div>
  <div>
     <div class="filter-group">
      <el-radio-group v-model="selectedStructure" @change="filteredTableData"  v-if="filteredTableData.length > 0">
       <div class="filter-title">类型：</div>
        <div class="radio-button-container">
          <el-radio-button
            v-for="(option, index) in types"
            :key="option.value"
            :label="option.value"
            :class="{ 'new-line': (index + 1) % 9 === 0 }"
          >
            {{ option.label }}
          </el-radio-button>
        </div>
      </el-radio-group>
    </div>


     <div class="filter-group">
      <el-radio-group v-model="selectedTimes" @change="filteredTableData"  v-if="filteredTableData.length > 0">
        <div class="filter-title">期权时长：</div>
        <el-radio-button
          v-for="option in times_options"
          :key="option.value"
          :label="option.value"
        >{{ option.label }}</el-radio-button>
      </el-radio-group>
    </div>

    <div class="filter-group">
      <el-radio-group v-model="selectedLockedTimes" @change="filteredTableData"  v-if="filteredTableData.length > 0">
        <div class="filter-title">锁定时长：</div>
        <el-radio-button
          v-for="option in locked_options"
          :key="option.value"
          :label="option.value"
        >{{ option.label }}</el-radio-button>
      </el-radio-group>
    </div>
       <div class="filter-group">
      <el-radio-group v-model="selectedInput" @change="filteredTableData"  v-if="filteredTableData.length > 0">
        <div class="filter-title">敲入：</div>
        <el-radio-button
          v-for="option in input_options"
          :key="option.value"
          :label="option.value"
        >{{ option.label }}</el-radio-button>
      </el-radio-group>
    </div>

     <div class="filter-group">
      <el-radio-group v-model="selectedOut" @change="filteredTableData"  v-if="filteredTableData.length > 0">
        <div class="filter-title">敲出：</div>
        <el-radio-button
          v-for="option in out_options"
          :key="option.value"
          :label="option.value"
        >{{ option.label }}</el-radio-button>
      </el-radio-group>
    </div>
     <div class="filter-group">
      <el-radio-group v-model="selectedSteps" @change="filteredTableData"  v-if="filteredTableData.length > 0">
        <div class="filter-title">降敲出步长：</div>
        <el-radio-button
          v-for="option in steps_options"
          :key="option.value"
          :label="option.value"
        >{{ option.label }}</el-radio-button>
      </el-radio-group>
    </div>

       <div class="filter-group">
      <el-radio-group v-model="selectedBD" @change="filteredTableData"  v-if="filteredTableData.length > 0">
        <div class="filter-title">保底：</div>
        <el-radio-button
          v-for="option in bd_options"
          :key="option.value"
          :label="option.value"
        >{{ option.label }}</el-radio-button>
      </el-radio-group>
    </div>
  <div class="filter-group">
      <el-radio-group v-model="selecteMargin" @change="filteredTableData"  v-if="filteredTableData.length > 0">
        <div class="filter-title">保证金：</div>
        <el-radio-button
          v-for="option in bzj_options"
          :key="option.value"
          :label="option.value"
        >{{ option.label }}</el-radio-button>
      </el-radio-group>
    </div>
    <div v-if="filteredTableData.length > 0">
      <KnockTable :tableData="filteredTableData" />
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import KnockTable from '@/components/KnockTable.vue';
import { formatDate } from '@/utils/commonMethods';
export default {
  name: 'KnockOutPage',
  components: {
    KnockTable
  },
  data() {
    return {
      date: new Date(),
      isSubmitting: false,
      searchQuery: '',
      warring: '',
      tableData: [],
      originalTableData: [],  // 添加原始数据副本
      selectedStructure: 'all',
      selectedBrokerage: 'all',  // 初始化为默认值
      selectedTimes:'all',
      selectedLockedTimes:'all',
      selectedInput:'all',
      selectedOut:'all',
      selectedSteps:'all',
      selectedBD:'all',
      selecteMargin:'all',

      types: [
            { value: 'all', label: '全部' },
            { value: '全保标准', label: '全保标准' },
            { value: '全保降敲', label: '全保降敲' },
            { value: '标准追保', label: '标准追保' },
            { value: '红利雪球', label: '红利雪球' },
            { value: '降敲追保', label: '降敲追保' },
            { value: '标准保底', label: '标准保底' },
            { value: '降敲保底', label: '降敲保底' },
            { value: '凤凰全保', label: '凤凰全保' },
            { value: '凤凰', label: '凤凰' },
            { value: '凤凰保底', label: '凤凰保底' },
            { value: 'FCN全保', label: 'FCN全保' },
            { value: 'FCN追保', label: 'FCN追保' },
            { value: 'FCN保底', label: 'FCN保底' },
            { value: 'DCN全保', label: 'DCN全保' },
            { value: 'DCN追保', label: 'DCN追保' },
            { value: 'DCN保底', label: 'DCN保底' },
            { value: '早利24M全保', label: '早利24M全保' },
            { value: '早利24M', label: '早利24M' }
      ],

      brokerage_options: [
        { value: 'all', label: '全部' },
        { value: '上证50', label: '上证50' },
        { value: '沪深300', label: '沪深300' },
        { value: '中证500', label: '中证500' },
        { value: '中证1000', label: '中证1000' }
      ],
       times_options: [
        { value: 'all', label: '全部' },
        { value: 12, label: '12M' },
        { value: 18, label: '18M' },
        { value: 24, label: '24M' }
      ],
      locked_options: [
        { value: 'all', label: '全部' },
        { value: 1, label: '1个月' },
        { value: 3, label: '3个月' }
      ],
       input_options: [
        { value: 'all', label: '全部' },
        { value: '70%', label: '70%' },
        { value: '75%', label: '75%' },
        { value: '80%', label: '80%' },
        { value: '85%', label: '85%' }
      ],
      out_options: [
        { value: 'all', label: '全部' },
        { value: '100%', label: '100%' },
        { value: '103%', label: '103%' }
      ],
      steps_options: [
        { value: 'all', label: '全部' },
        { value: '0%',  label: '0%' },
       { value: '0.50%',  label: '0.50%' },
        { value: '1.00%',  label: '1.00%' }
      ],
      bd_options: [
        { value: 'all', label: '全部' },
         { value: '0%', label: '0%' },
        { value: '75%', label: '75%' },
        { value: '70%', label: '70%' },
        { value: '80%', label: '80%' },
        { value: '85%', label: '85%' },
        { value: '90%', label: '90%' },
        { value: '95%', label: '95%' }

      ],
      bzj_options: [
        { value: 'all', label: '全部' },
        { value: '15.00%', label: '15.00%' },
        { value: '20.00%', label: '20.00%' },
        { value: '25.00%', label: '25.00%' },
        { value: '30.00%', label: '30.00%' },
        { value: '100.00%', label: '100.00%' }

      ],

      total_principal: '1',  // 初始化为默认值
      total_principal_label: '100w',  // 用于存储 label 值
      containerDisplay:false,
      loading: false, // ✅ 新增 loading 状态
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalRecords / this.perPage);
    },
    filteredTableData() {
       let filteredData = [...this.originalTableData]; // 使用原始数据副本

       console.log(filteredData);
      // 结构筛选
        if (this.selectedStructure!== 'all') {
          filteredData = filteredData.filter(item =>
            item.structure === this.selectedStructure
          );
        }


          // 期权时长筛选
        if (this.selectedTimes!== 'all') {
          filteredData = filteredData.filter(item =>
            item.times === this.selectedTimes
          );
        }

        // 锁定时长筛选
    if (this.selectedLockedTimes!== 'all') {
      filteredData = filteredData.filter(item =>
        item.locked === this.selectedLockedTimes
      );
    }
 // 敲入筛选
    if (this.selectedInput!== 'all') {
      filteredData = filteredData.filter(item =>
        item.input === this.selectedInput
      );
    }

    // 敲出筛选
    if (this.selectedOut!== 'all') {
      filteredData = filteredData.filter(item =>
        item.out === this.selectedOut
      );
    }
      // 步长筛选
    if (this.selectedSteps !== 'all') {
      filteredData = filteredData.filter(item =>
        item.step === this.selectedSteps
      );
    }

       // 保底筛选
    if (this.selectedBD !== 'all') {
      filteredData = filteredData.filter(item =>
        item.total_principal_label === this.selectedBD
      );
    }
        // 保证金筛选
    if (this.selecteMargin !== 'all') {
      filteredData = filteredData.filter(item =>
        item.margin === this.selecteMargin
      );
    }



      return filteredData;
    }
  },
  methods: {

      // 新增统一筛选触发方法
    applyFilters() {
      this.tableData = [];
      this.originalTableData = [];
      this.selectedStructure='all';
      this.selectedTimes='all';
      this.selectedLockedTimes='all';
      this.selectedInput='all';
      this.selectedOut='all';
      this.selectedSteps='all';
      this.selectedBD='all';
      this.selecteMargin='all';
      this.fetchData();
    },
    async fetchData() {
      const date = formatDate(this.date);
      console.log(date);
      this.loading = true; // ✅ 显示加载动画
      try {

        const response = await axios.get(`/api/knockout`,{
             headers: {
                 'Authorization': `Bearer ${this.$store.getters.token}`
             },
             params: {
                brokerage: this.selectedBrokerage,
                now_date: date
             } // 自动序列化为查询参数
        });
        const responseData = response.data;
        if (responseData == null) {
          this.warring = '没有找到相关数据，请检查输入的股票代码是否是两融标的。';
          this.data = {};
          this.tableData = [];
          this.containerDisplay = true;
        } else {
          this.originalTableData = this.generateTableData(responseData); // 调用数据转换方法
          this.tableData = [...this.originalTableData]; // 同步展示数据
          this.containerDisplay = false;
        }
      } catch (error) {
         if (error.response && error.response.data && error.response.data.detail) {
            this.$message.error(error.response.data.detail);
          } else {
             this.$message.error(error.error || '请求失败，请稍后重试。');
          }

      } finally {
        this.loading = false; // ✅ 隐藏加载动画
        console.log('请求完成');
      }
    },
     // 新增数据转换方法（假设返回格式为二维数组）
    generateTableData(rawData) {
      return rawData.map(row => ({
          stock_code: row[0], // 标的名称
          stock_name: row[1], // 标的代码
          structure: row[2], // 类型
          times: row[3],    // 期限月数
          locked: row[4],   // 锁定月数
          input: this.formatToPercent(row[5]),    // 敲入
          out: this.formatToPercent(row[6]),      // 敲出
          step: this.formatToPercent(row[7],2),     // 降敲出步长
          total_principal: this.formatToPercent(row[8]), // 执行价
          total_principal_label:  this.formatToPercent(row[9]),// 保底
          brokerage: this.formatToPercent(row[10],2),//红利票息
          margin: this.formatToPercent(row[11],2),//保证金
          quoted : this.formatToPercent(row[12],2), // 报价年化票息
          secondary: row[13], // 早利雪球二级票息率(年化)
      // 其他字段按需添加...
    }));
    },
    formatToPercent(value, defaultVal = 0) {

      const num = parseFloat(value).toFixed(5); // 转换为数字
      if(isNaN(num)){
        return '0%'
      }
      return (num * 100).toFixed(defaultVal) + '%';
    }

  }
}
</script>
<style>
.filter-group {
  margin: 20px 0;
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.el-radio-group {
  display: flex;
  align-items: center;
  background: #f5f7fa;
  border-radius: 4px;
  padding: 8px 10px;
}

.filter-title {
  margin-right: 10px;
  font-size: 14px;
  color: #606266;
}

.el-radio-button {
  margin-left: 8px;
}

.el-radio-button:first-child {
  margin-left: 0;
}

.el-radio-button__inner {
  padding: 8px 15px;
}
.page-container {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.title-section {
  margin-bottom: 30px;
}

.rules-container {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 40px;
}

.rule-group {
  margin-bottom: 25px;
}

.rule-group:last-child {
  margin-bottom: 0;
}

.rule-item {
  margin: 8px 0;
  font-size: 14px;
  line-height: 1.5;
}
.loading-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-spinner {
  border: 4px solid #f3f3f3;
  border-radius: 50%;
  border-top: 4px solid #3498db;
  width: 50px;
  height: 50px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}


</style>